/**
 * Social Proof Section
 *
 * Aspirational scenario vignettes that help visitors imagine life with
 * Scheduled Smiles. Uses first-person "what if" framing rather than
 * fake testimonials — honest about being aspirational, not pretending
 * to be real user quotes.
 *
 * Placed after "How It Works" to reinforce the value before showing
 * the template gallery.
 */

import { Paper, SimpleGrid, Stack, Text, Title, ThemeIcon, rem } from '@mantine/core';
import { IconQuote } from '@tabler/icons-react';
import { brandColors, semanticColors } from '../../config/theme';
import { landingContent } from '../../content/landingContent';

/**
 * Renders aspirational scenario cards showing what life looks like
 * when you never forget another important date.
 */
export const SocialProofSection = () => {
  const { title, scenarios } = landingContent.sections.socialProof;

  return (
    <Stack gap="lg">
      <Title order={2} ta="center" c={semanticColors.text.title}>
        {title}
      </Title>

      <SimpleGrid cols={{ base: 1, sm: 3 }} spacing="lg">
        {scenarios.map((scenario) => (
          <Paper
            key={scenario}
            radius="lg"
            p="lg"
            style={{
              background: semanticColors.bg.sectionWarm,
              border: `1px solid ${semanticColors.border.default}`,
            }}
          >
            <Stack gap="md">
              <ThemeIcon
                size={36}
                radius="xl"
                color={brandColors.scheduling}
                variant="light"
              >
                <IconQuote size={18} />
              </ThemeIcon>
              <Text
                size="md"
                c={semanticColors.text.heading}
                style={{ fontStyle: 'italic', lineHeight: 1.6, fontSize: rem(15) }}
              >
                {scenario}
              </Text>
            </Stack>
          </Paper>
        ))}
      </SimpleGrid>
    </Stack>
  );
};
